<template> 
  <dd-icon-button
    :title="title" 
    :size="size" 
    :color="color" 
    class="quick-add-button" 
    icon="plus"
    type="circle"
  />
</template>
             
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'QuickAddButton',

  props: {
    title: {
      type: String,
      default: 'Add New',
    },
    size: {
      type: String,
      default: 'tiny',
    },
    color: {
      type: String,
      default: 'grey',
    },
  },
})
</script>
